import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import './ButtonSpacer.css'

const ButtonSpacer = ({ vertical }) => <div styleName={cx({vertical})} />

ButtonSpacer.propTypes = {
  vertical: PropTypes.bool
}

export default ButtonSpacer
